module.exports = __webpack_public_path__ + "static/img/6.fb0b141.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/3/1/sp/6.png
// module id = FbvY
// module chunks = 0